import React, { useEffect, useState } from 'react';
import Select from 'components/Select';
import { FormikTouched } from 'formik';
import * as S from './styles';
import { FormPropsPJType } from 'pages/Register/utils/types/FormPropType/FormPropPJType';
import { findData } from 'services/findCEP';
import { toast } from 'react-toastify';

type InputsAndSelectsOfCompanyDataProps = {
  values: FormPropsPJType;
  errorsForm: FormPropsPJType | undefined;
  successForm: FormPropsPJType | undefined;
  touched: FormikTouched<FormPropsPJType>;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined
  ) => void;
};

export const InputsAndSelectsOfCompanyData: React.FC<
  InputsAndSelectsOfCompanyDataProps
> = ({ values, errorsForm, successForm, touched, setFieldValue }) => {
  const [tiposEmpresas, setTiposEmpresas] = useState<any[]>([]);
  const [portesEmpresas, setPortesEmpresas] = useState<any[]>([]);
  const [classesEconomicas, setClassesEconomicas] = useState<any[]>([]);

  useEffect(() => {
    findData
      .GetTipoEmpresa()
      .then((response) => {
        setTiposEmpresas(response.data.data);
      })
      .catch(() => {
        toast.error(
          'Não foi possível carregar os Tipos de Empresa, por favor atualize a página'
        );
      });

    findData
      .GetPorteEmpresa()
      .then((response) => {
        setPortesEmpresas(response.data.data);
      })
      .catch(() => {
        toast.error(
          'Não foi possível carregar os Portes Empresa, por favor atualize a página'
        );
      });

    findData
      .GetClasseEconomicaEmpresa()
      .then((response) => {
        setClassesEconomicas(response.data.data);
      })
      .catch(() => {
        toast.error(
          'Não foi possível carregar as Classes Econômicas, por favor atualize a página'
        );
      });
  }, []);

  return (
    <S.Wrapper>
      <S.DivInput>
        <Select
          title="Tipo empresa"
          name="tipoEmpresa"
          value={values.tipoEmpresa}
          error={
            errorsForm?.tipoEmpresa === 'true' &&
            successForm?.tipoEmpresa === 'false'
          }
          valid={
            !!values.tipoEmpresa &&
            !!touched.tipoEmpresa &&
            errorsForm?.tipoEmpresa === 'false'
          }
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
            setFieldValue('tipoEmpresa', event.target.value);
          }}
        >
          <option value="" hidden>
            Selecione uma opção
          </option>
          {tiposEmpresas?.map((val) => (
            <option key={val.codigo} value={val.codigo}>
              {val.descricao}
            </option>
          ))}
        </Select>

        <Select
          title="Porte empresa"
          name="porteEmpresa"
          value={values.porteEmpresa}
          error={
            errorsForm?.porteEmpresa === 'true' &&
            successForm?.porteEmpresa === 'false'
          }
          valid={
            !!values.porteEmpresa &&
            !!touched.porteEmpresa &&
            errorsForm?.porteEmpresa === 'false'
          }
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
            setFieldValue('porteEmpresa', event.target.value);
          }}
        >
          <option value="" hidden>
            Selecione uma opção
          </option>
          {portesEmpresas?.map((val) => (
            <option key={val.codigo} value={val.codigo}>
              {val.descricao}
            </option>
          ))}
        </Select>

        <Select
          title="Classe econômica"
          name="classeEconomica"
          value={values.classeEconomica}
          error={
            errorsForm?.classeEconomica === 'true' &&
            successForm?.classeEconomica === 'false'
          }
          valid={
            !!values.classeEconomica &&
            !!touched.classeEconomica &&
            errorsForm?.classeEconomica === 'false'
          }
          onChange={(event: React.ChangeEvent<HTMLSelectElement>) => {
            setFieldValue('classeEconomica', event.target.value);
          }}
        >
          <option value="" hidden>
            Selecione uma opção
          </option>
          {classesEconomicas?.map((val) => (
            <option key={val.codigo} value={val.codigo}>
              {val.descricao}
            </option>
          ))}
        </Select>
      </S.DivInput>
    </S.Wrapper>
  );
};
